import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { confirmOrder } from '../helpers/confirm-order';

interface ConfirmOrderForSubscriptionCancellationFnPayload {
    orderId: string;
}

export type ConfirmOrderForSubscriptionCancellationFn = (
    payload: ConfirmOrderForSubscriptionCancellationFnPayload,
) => Promise<{
    cancellationReference: string;
    cancellationType: string;
}>;

export function initConfirmOrderForSubscriptionCancellationFn({
    dependencies,
}: DomainInitPayload): ConfirmOrderForSubscriptionCancellationFn {
    return async ({
        orderId,
    }: ConfirmOrderForSubscriptionCancellationFnPayload) => {
        try {
            const { cancelSubscription } = await confirmOrder(
                { orderId },
                dependencies,
            );
            if (!cancelSubscription) {
                throw new Error('Cancel subscription not created.');
            }
            // TODO: add analytics tracking
            return cancelSubscription;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
